import type { PortalProviderAPI } from '@atlaskit/editor-common/portal';

import type { HubExternalInsertPlugin } from './hubExternalInsertPluginType';
import { createPlugin, key } from './pm-plugins/main';

export const hubExternalInsertPlugin: HubExternalInsertPlugin = ({ api }) => ({
	name: 'hubExternalInsert',
	getSharedState(editorState) {
		if (!editorState) {
			return undefined;
		}
		const pluginState = key.getState(editorState);
		return pluginState ? { dropTargetPos: pluginState.dropTargetPos } : undefined;
	},
	pmPlugins() {
		return [
			{
				name: 'hubExternalInsert',
				plugin: ({
					nodeViewPortalProviderAPI,
				}: {
					nodeViewPortalProviderAPI?: PortalProviderAPI;
				}) => {
					return createPlugin(api, nodeViewPortalProviderAPI);
				},
			},
		];
	},
});
